import ComparisonTable from '@/components/base/ComparisonTable';

const comparisonRows = [
  { feature: 'Ease of Use', litbuy: '★★★★★', alternative: '★★★' },
  { feature: 'Automation', litbuy: 'Built-in & Automatic', alternative: 'Limited / Manual Only' },
  { feature: 'Real-Time Tracking', litbuy: 'Yes, Live Updates', alternative: 'Manual Refresh Required' },
  { feature: 'Template Library', litbuy: 'Extensive Collection', alternative: 'Basic Templates' },
  { feature: 'Collaboration', litbuy: 'Seamless Multi-User', alternative: 'Limited Sharing' },
  { feature: 'Data Security', litbuy: 'Enterprise-Grade Encryption', alternative: 'Varies by Platform' },
  { feature: 'Updates & Support', litbuy: 'Automatic & 24/7', alternative: 'Manual / Community-Based' },
  { feature: 'Learning Curve', litbuy: 'Minimal, Intuitive UI', alternative: 'Steep for Advanced Features' },
];

export default function ComparisonSection() {
  return (
    <section className="relative bg-secondary-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="mb-4">
            <span className="text-xs tracking-widest uppercase text-accent-600 font-medium">/ Comparison</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 leading-snug max-w-2xl">
            Litbuy Spreadsheet vs Traditional Methods — See the Difference
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl">
            A side-by-side breakdown of how Litbuy Spreadsheet outperforms conventional approaches. From automation to security, every aspect is designed for modern productivity.
          </p>

          <div className="mt-10">
            <ComparisonTable rows={comparisonRows} />
          </div>

          <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <div className="flex -space-x-2">
                {[1, 2, 3].map((i) => (
                  <div
                    key={i}
                    className="w-8 h-8 rounded-full bg-secondary-300 border-2 border-secondary-50 flex items-center justify-center"
                  >
                    <span className="text-[10px] font-semibold text-foreground-600">{i}</span>
                  </div>
                ))}
              </div>
              <span className="text-xs text-foreground-500">Trusted by 10,000+ users worldwide</span>
            </div>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap inline-flex items-center gap-2 text-sm font-medium text-primary-600 transition-colors duration-200 cursor-pointer hover:text-primary-700"
            >
              Try Litbuy Spreadsheet
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}